import { User } from "features/panelManagement/accessManagement/types/access";
import { getToken } from "features/auth/functions/token";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";
import listAllUsers from "./access.listAllUsers";

const createUser =
    (params: User): AppThunk<Promise<any>> =>
    (dispatch) => {
        return getDataFromRequest(
            ENDPOINT.FUNCTIONS_API.USERS,
            HTTPMethods.POST,
            getToken(),
            {
                email: params.email,
                displayName: params.displayName,
                password: params.password,
                role: params.role,
            }
        ).then((res) => {
            dispatch(listAllUsers());
            return res;
        });
    };

export default createUser;
